<template>
  <div class="animated fadeIn page-shell">
    <HeaderPadrao class="mb-2" icon="fa fa-truck" titulo="ORDEM DE EXPEDIÇÃO">
      <template #subtitulo>
        <i class="fa fa-tag mr-1 text-info"></i>
        Id: <strong class="text-white">{{ registro.ID > 0 ? registro.ID : 'Novo' }}</strong>
        <span class="mx-2">•</span>
        <i class="fa fa-info-circle mr-1 text-info"></i>
        Situação: <strong class="text-white">{{ traduzStatus }}</strong>
      </template>

      <template #acoes>
        <b-button v-if="exibirBotaoFinalizar" variant="link" class="btn-glass btn-glass-success" @click.stop.prevent="onLiberarTerminal(true)">
          <i class="fa fa-check mr-1"></i> Liberar Terminal
        </b-button>

        <b-button v-if="exibirBotaoGravar" variant="link" class="btn-glass btn-glass-primary" @click.stop.prevent="onGravarNovo()">
          <i class="fa fa-save mr-1"></i> Gravar
        </b-button>

        <b-button v-if="exibirBotaoReabrir" variant="link" class="btn-glass btn-glass-warning" @click.stop.prevent="onReabrir()">
          <i class="fa fa-unlock mr-1"></i> Reabrir
        </b-button>

        <b-button variant="light" pill class="ml-2 font-weight-bold shadow-sm" @click.stop.prevent="onVoltarPrincipal()">
          <i class="fa fa-arrow-left mr-1"></i> Voltar
        </b-button>
      </template>
    </HeaderPadrao>

    <div class="page-main px-3">
        <b-card no-body class="border-0 shadow-sm mb-4 rounded-lg">
          <div class="card-header bg-white border-bottom-0 py-3">
            <h5 class="mb-0 text-primary font-weight-bold">
              <i class='fa fa-list-alt mr-2'></i>Dados da Expedição
            </h5>
          </div>
          <b-card-body class="pt-0">
            <b-row>
              <!--/.col-->
              <b-col sm="2">
                <b-form-group label="Código ID" label-class="modal-label-premium">
                  <b-form-input type="text" id="edID" :disabled="true" class="rounded-pill bg-light border-0 shadow-xs" placeholder="Código Automático" v-model="registro.ID"></b-form-input>
                </b-form-group>
              </b-col>
            
              
              <!--/.col-->
              <b-col sm="2">
                <b-form-group label="Data Cadastro" label-class="modal-label-premium">
                  <b-form-input  type="date" id="edDT_LANCAMENTO" :disabled="true" class="rounded-pill bg-light border-0 shadow-xs" v-model="registro.DATA_CADASTRO" placeholder="" > </b-form-input>
                </b-form-group>
              </b-col>  
              <!--/.col-->
              <b-col sm="3">
                <b-form-group label="Situação" label-class="modal-label-premium">
                  <b-form-input  type="text" id="edSituacao" :disabled="true" class="rounded-pill bg-light border-0 shadow-xs" v-model="traduzStatus" placeholder="" > </b-form-input>
                </b-form-group>
              </b-col> 
               <!--/.col-->
              <b-col sm="2">
                <b-form-group label="Data Planejada" label-class="modal-label-premium">
                  <b-form-input  type="date" id="edDATA" :disabled="desabilitarQuandoFechado" class="rounded-pill shadow-xs" v-model="registro.DATA" :state="registro.DATA != null" placeholder="" > </b-form-input>
                </b-form-group>
              </b-col>
              <!--/.col-->
              <b-col sm="3">
                <b-form-group label="Sequencia" label-class="modal-label-premium">
                  <b-form-input  type="text" id="edNUMERO" :disabled="desabilitarQuandoFechado" class="rounded-pill shadow-xs" v-model="registro.NUMERO" :state="registro.NUMERO != null" placeholder="" > </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>  
            
            <b-row class="mt-2">

              <b-col sm="4">
               <b-form-group label="Conferente" label-class="modal-label-premium">
                    <funcionario-dropdown
                      v-model="registro.RESPONSAVEL_ID"
                      :disabled="desabilitarQuandoFechado"
                      input-class="rounded-pill shadow-xs"
                      :placeholder="'Pesquise pelo nome do conferente...'"
                      :state="!!registro.RESPONSAVEL_ID"
                    />
                </b-form-group>
              </b-col>

              <b-col sm="4">
                <b-form-group label="Motorista" label-class="modal-label-premium">
                    <funcionario-dropdown
                      v-model="registro.MOTORISTA_ID"
                      :disabled="desabilitarQuandoFechado"
                      input-class="rounded-pill shadow-xs"
                      :placeholder="'Pesquise pelo nome do motorista...'"
                      :state="!!registro.MOTORISTA_ID"
                    />
                </b-form-group>
              </b-col>
              <b-col sm="4">
                  <b-form-group label="Veiculo" label-class="modal-label-premium">
                    <veiculo-dropdown
                      v-model="registro.VEICULO_ID"
                      :disabled="desabilitarQuandoFechado"
                      input-class="rounded-pill shadow-xs"
                      :placeholder="'Pesquise pelo nome do veiculo...'"
                      :state="!!registro.VEICULO_ID"
                    />
                </b-form-group>
              </b-col>
             
            </b-row>
            <b-row class="mt-2">
               <b-col sm="2">
                  <b-form-group label="Confirme a Placa" label-class="modal-label-premium">
                    <b-form-input  type="text" id="edPLACA" :disabled="desabilitarQuandoFechado" class="rounded-pill shadow-xs" v-model="registro.PLACA" :state="registro.PLACA != null" placeholder="" > </b-form-input>
                  </b-form-group>
                </b-col>
            </b-row>
          </b-card-body>
        </b-card>
           
        <b-row>
            <b-col sm="6">
            <b-card no-body class="border-0 shadow-sm rounded-lg h-100">
              <div class="card-header bg-white border-bottom-0 py-3 d-flex justify-content-between align-items-center">
                <h5 class="mb-0 text-primary font-weight-bold">
                  <i class='fa fa-clock-o mr-2'></i>Aguardando Embarque
                </h5>
                <b-button size="sm" variant="outline-primary" class="rounded-pill" @click="atualizarListaPedidosDisponiveis" :disabled="tabelaPedidosDisponiveis.isLoading" title="Atualizar Lista" v-b-tooltip.hover.left>
                  <i class="fa fa-refresh" :class="{'fa-spin': tabelaPedidosDisponiveis.isLoading}"></i>
                </b-button>
              </div>
              <b-card-body class="p-0">
              <b-table class="table table-sm"
                    show-empty
                    empty-text="Nenhum Pedido Aguardando "
                    stacked="sm"
                    small
                    responsive 
                    caption-top
                    sticky-header
                    striped 
                    hover 
                    :busy.sync="tabelaPedidosDisponiveis.isBusy" 
                    :items="tabelaPedidosDisponiveis.items" 
                    :fields="tabelaPedidosDisponiveis.fields"
                    :current-page="tabelaPedidosDisponiveis.currentPage"
                    :per-page="tabelaPedidosDisponiveis.perPage"
                    select-mode="single"
                    @row-clicked="toggleDetalhesPedido"
                    >
                  <template #cell(DETALHE)="row">
                    <i 
                      :class="row.detailsShowing ? 'fa fa-angle-up' : 'fa fa-angle-down'"
                      @click.stop="toggleDetalhesPedido(row)"
                      style="cursor: pointer"
                    ></i>
                  </template>
                  <template #row-details="row">
                    <div v-if="row.item.loading">
                      Carregando detalhes...
                    </div>
                    <div v-else>
                      <b-table 
                        head-variant="dark"
                        :hover="false"
                        table-variant="light"
                        :items="row.item.detalhes" 
                        :fields="tabelaItens.fields">
                      </b-table>
                    </div>
                  </template>
              
                  <template #cell(OP_PEDIDO)="tipo">
                    <b-badge pill :variant="colorirTipoPedido(tipo.item.OP_PEDIDO)">{{traduzirTipoPedido(tipo.item.OP_PEDIDO)}}</b-badge>
                  </template>    
                  <template #cell(actions)="item">
                    <b-button  v-if="exibirBotaoReabrir == false" :disabled="tabelaPedidosDisponiveis.isLoading || tabelaPedidosEmbarcados.isLoading"  type="button"  size="sm" variant="success" title="Embarcar" @click.stop.prevent="addPedido(item.item.SEQUENCIA)" v-b-tooltip.hover.left>
                      <b-spinner v-if="tabelaPedidosDisponiveis.isLoading || tabelaPedidosEmbarcados.isLoading" small type="border" class="p-0"></b-spinner>
                      <i v-else class="fa fa-arrow-right"></i>
                    </b-button>
                
                  </template>
              </b-table>
            </b-card-body>
            </b-card>  

            </b-col>
            <b-col sm="6">
            <b-card no-body class="border-0 shadow-sm rounded-lg h-100">
              <div class="card-header bg-white border-bottom-0 py-3">
                <h5 class="mb-0 text-primary font-weight-bold">
                  <i class='fa fa-list mr-2'></i>Nesse Embarque
                </h5>
              </div>
              <b-card-body class="p-0">
              <b-table class="table table-sm"
                    show-empty
                    id="tabelaPedidosEmbarcados"
                    empty-text="Nenhum Pedido nessa Ordem "
                    stacked="sm"
                    small
                    responsive 
                    caption-top
                    sticky-header
                    striped 
                    hover 
                    :busy.sync="tabelaPedidosEmbarcados.isBusy" 
                    :items="tabelaPedidosEmbarcados.items" 
                    :fields="tabelaPedidosEmbarcados.fields"
                    :current-page="tabelaPedidosEmbarcados.currentPage"
                    :per-page="tabelaPedidosEmbarcados.perPage"
                    select-mode="single"
                    @row-clicked="toggleDetalhesPedido"
                    >
                  <template #cell(DETALHE)="row">
                    <i 
                      :class="row.detailsShowing ? 'fa fa-angle-up' : 'fa fa-angle-down'"
                      @click.stop="toggleDetalhesPedido(row)"
                      style="cursor: pointer"
                    ></i>
                  </template>
                  <template #row-details="row">
                    <div v-if="row.item.loading">
                      Carregando detalhes...
                    </div>
                    <div v-else>
                      <b-table 
                        head-variant="dark"
                        :hover="false"
                        table-variant="light"
                        :items="row.item.detalhes" 
                        :fields="tabelaItens.fields">
                      </b-table>
                    </div>
                  </template>
              
                  <template #cell(OP_PEDIDO)="tipo">
                    <b-badge pill :variant="colorirTipoPedido(tipo.item.OP_PEDIDO)">{{traduzirTipoPedido(tipo.item.OP_PEDIDO)}}</b-badge>
                  </template>    
                  <template v-if="exibirBotaoReabrir == false" #cell(actions)="item">
                    <div class="d-flex justify-content-end">
                      <b-button v-if="parametrosGerais.OP_EXPEDICAO_POR_LOTE === '1'"
                                :disabled="tabelaPedidosDisponiveis.isLoading || tabelaPedidosEmbarcados.isLoading"
                                type="button" size="sm" 
                                :variant="item.item.QUANT_VINCULADA >= item.item.QUANT_TOTAL_ITENS ? 'success' : (item.item.QUANT_VINCULADA > 0 ? 'warning' : 'info')" 
                                :title="item.item.QUANT_VINCULADA >= item.item.QUANT_TOTAL_ITENS ? 'Lotes Completos' : (item.item.QUANT_VINCULADA > 0 ? 'Vínculo Parcial' : 'Vincular Lotes')" 
                                class="mr-1 shadow-sm" @click.stop.prevent="abrirModalVincularLotes(item.item)" v-b-tooltip.hover.left>
                        <i :class="item.item.QUANT_VINCULADA >= item.item.QUANT_TOTAL_ITENS ? 'fa fa-check-circle' : (item.item.QUANT_VINCULADA > 0 ? 'fa fa-exclamation-triangle' : 'fa fa-cubes')"></i>
                      </b-button>
                      <b-button :disabled="tabelaPedidosDisponiveis.isLoading || tabelaPedidosEmbarcados.isLoading" 
                                type="button" size="sm" variant="danger" title="Remover" 
                                @click.stop.prevent="delPedido(item.item.SEQUENCIA)" v-b-tooltip.hover.left>
                        <b-spinner v-if="tabelaPedidosDisponiveis.isLoading || tabelaPedidosEmbarcados.isLoading" small type="border" class="p-0"></b-spinner>
                        <i v-else class="fa fa-arrow-left"></i>
                      </b-button>
                    </div>
                  </template>

                  <template #cell(NENTREGA)="row">
                     <b-button size="sm" variant="outline-dark" @click="openEditEntrega(row.item)" v-b-tooltip.hover >
                        {{ row.item.NENTREGA ? row.item.NENTREGA : '0' }} <i class="fa fa-pencil"></i>
                      </b-button>
                  </template>
                
              </b-table>
            </b-card-body>
            </b-card>  
          </b-col>
        </b-row>

        <!-- TABELA DE TOTALIZADOS -->
        <b-row class="mt-3" v-if="registro.ID">
          <b-col>
            <b-card no-body class="border-0 shadow-sm rounded-lg mt-3">
              <div class="card-header bg-white border-bottom-0 py-3">
                 <h5 class="mb-0 text-primary font-weight-bold">
                  <i class='fa fa-calculator mr-2'></i>Totalizados
                </h5>
              </div>
              <b-card-body class="pt-0">
              
              <b-row class="mb-3">
                <b-col>
                  <b-form-group label="Totalizar Por:" label-cols="2">
                    <b-form-radio-group v-model="totalizados.agrupamento" buttons button-variant="outline-primary" size="sm">
                      <b-form-radio value="produto">Por Produto</b-form-radio>
                      <b-form-radio value="cliente">Por Cliente</b-form-radio>
                      <b-form-radio value="vendedor">Por Vendedor</b-form-radio>
                      <b-form-radio value="municipio">Por Município</b-form-radio>
                    </b-form-radio-group>
                  </b-form-group>
                </b-col>
                <b-col cols="auto">
                  <b-button variant="primary" size="sm" @click="imprimirTotalizados" :disabled="!totalizadosAgrupados.length">
                    <i class="fa fa-print"></i> Imprimir
                  </b-button>
                </b-col>
              </b-row>

              <b-table
                :items="totalizadosAgrupados"
                :fields="totalizados.fields"
                striped
                small
                hover
                responsive
                show-empty
                empty-text="Nenhum dado disponível"
                :foot-clone="totalizadosAgrupados.length > 0"
                @row-clicked="toggleDetalhesTotalizados">
                <template #cell(DETALHE)="row" v-if="totalizados.agrupamento === 'cliente'">
                  <i 
                    :class="row.detailsShowing ? 'fa fa-angle-up' : 'fa fa-angle-down'"
                    @click.stop="toggleDetalhesTotalizados(row)"
                    style="cursor: pointer"
                  ></i>
                </template>
                <template #cell(QUANT)="data">
                  {{ data.value.toLocaleString('pt-BR', {minimumFractionDigits: 3}) }}
                </template>
                <template #foot()="">
                  <span></span>
                </template>
                <template #foot(AGRUPAMENTO)="">
                  <strong>TOTAL GERAL</strong>
                </template>
                <template #foot(QUANT)="">
                  <strong>{{ totalGeral.QUANT.toLocaleString('pt-BR', {minimumFractionDigits: 3}) }}</strong>
                </template>
                <template #foot(PECAS)="">
                  <strong>{{ totalGeral.PECAS }}</strong>
                </template>
                <template #foot(PECAS_PEDIDO)="">
                  <strong>{{ totalGeral.PECAS_PEDIDO }}</strong>
                </template>
                <template #row-details="row" v-if="totalizados.agrupamento === 'cliente'">
                  <div v-if="row.item.loading">
                    Carregando detalhes...
                  </div>
                  <div v-else>
                    <b-table 
                      head-variant="dark"
                      :hover="false"
                      table-variant="light"
                      :items="row.item.detalhes" 
                      :fields="tabelaProdutosCliente.fields"
                      small>
                    </b-table>
                  </div>
                </template>
              </b-table>
            </b-card-body>
            </b-card>
          </b-col>
        </b-row>
          
        

        
    </div>
    

    
    <b-modal id="modal-editar-entrega" centered title="Editar Entrega" @ok="salvarEntrega">
      <b-form-group label="Número da Entrega">
        <vue-autonumeric
          v-model="novoNEntrega"
          :options="{
            digitGroupSeparator: '',
            decimalCharacter: ',',
            decimalPlaces: 0,
            minimumValue: '0',
            outputFormat: 'number'
          }"
          class="form-control"
        ></vue-autonumeric>
      </b-form-group>
    </b-modal>

    <!-- MODAL VINCULAR LOTES (PREMIUM) -->
    <b-modal id="modal-vincular-lotes" 
             size="xl" 
             centered 
             title="PLANEJAMENTO DE LOTES POR PEDIDO" 
             header-bg-variant="dark" 
             header-text-variant="white"
             @ok="salvarVinculoLotes"
             body-class="p-0"
             no-close-on-backdrop>
      
      <!-- ─── HEADER FIXO DE RESUMO ─── -->
      <div class="ev-fixed-top-bar border-bottom bg-white d-flex align-items-center px-3 py-2 shadow-sm">
        <div class="ev-sidebar-title" style="width: 255px;">
          <span class="font-weight-bold text-dark small"><i class="fa fa-tasks mr-2 text-primary"></i>CHECKLIST PRODUTOS</span>
        </div>
        <div class="flex-grow-1 d-flex align-items-center gap-3">
           <div class="ev-stat-mini">
              <label>PEDIDO</label>
              <div class="value text-primary">#{{ pedidoLoteEdicao ? pedidoLoteEdicao.N_VENDA : '' }}</div>
           </div>
           <div class="ev-stat-mini flex-grow-1">
              <label>CLIENTE</label>
              <div class="value text-dark text-truncate" style="max-width: 300px;">{{ pedidoLoteEdicao ? pedidoLoteEdicao.NOME_CLIENTE : '' }}</div>
           </div>
           <div class="ev-stat-mini" style="min-width: 150px">
              <div class="d-flex justify-content-between align-items-end mb-1">
                <label class="m-0">VÍNCULO TOTAL</label>
                <span class="font-weight-bold text-dark small">{{ calcProgressoGeralVinculo() }}%</span>
              </div>
              <b-progress :value="calcProgressoGeralVinculo()" :max="100" variant="success" style="height: 10px; border-radius: 5px;" />
           </div>
        </div>
      </div>

      <div class="ev-modal-body p-0 bg-soft-grey d-flex" style="height: 70vh; overflow: hidden;">
        <b-overlay :show="carregandoLotes" rounded="sm" opacity="0.6" class="w-100 h-100 d-flex">
          
          <!-- Sidebar de Navegação Rápida -->
          <div class="ev-sidebar d-none d-lg-flex flex-column border-right bg-white" style="width: 280px;">
            <div class="flex-grow-1 overflow-auto p-2">
              <div v-for="(item, idx) in itensPedidoLote" :key="'nav-lote-'+idx" 
                   class="ev-nav-item p-3 mb-2 rounded border d-flex align-items-center gap-3"
                   :class="{'ev-nav-item--active': activeIndex === idx, 'ev-nav-item--done': somaLotes(item) >= item.QUANT}"
                   @click="scrollToItem(idx)">
                <div class="ev-nav-dot"></div>
                <div class="flex-grow-1 overflow-hidden">
                  <div class="text-truncate font-weight-bold" :class="activeIndex === idx ? 'text-primary' : 'text-dark'" style="font-size: 0.85rem">{{ item.NOME_PRODUTO }}</div>
                  <div class="font-xs text-muted">{{ somaLotes(item).toLocaleString() }} / {{ item.QUANT.toLocaleString() }}</div>
                </div>
                <i v-if="somaLotes(item) >= item.QUANT" class="fa fa-check-circle text-success"></i>
              </div>
            </div>
          </div>

          <!-- Feed Principal de Cards -->
          <div class="ev-feed flex-grow-1 overflow-auto p-4" id="ev-scroll-container-lotes">
            <div v-for="(item, idx) in itensPedidoLote" :key="item.CONTROLE" :id="'item-card-lote-'+idx" 
                 class="ev-item-card mb-4 bg-white shadow-sm border rounded-lg overflow-hidden"
                 :class="{'ev-item-card--done': somaLotes(item) >= item.QUANT, 'ev-item-card--active': activeIndex === idx}">
              
              <!-- Header do Card -->
              <div class="ev-item-card-header p-3 border-bottom d-flex align-items-center justify-content-between"
                   :class="somaLotes(item) >= item.QUANT ? 'bg-soft-success' : (activeIndex === idx ? 'bg-soft-blue' : 'bg-light')">
                <div class="d-flex align-items-center gap-3">
                  <div class="ev-item-index">{{ idx + 1 }}</div>
                  <div>
                    <h5 class="m-0 font-weight-bold text-dark">{{ item.NOME_PRODUTO }}</h5>
                    <div class="font-xs text-muted text-uppercase">CÓDIGO: {{ item.COD_PRO }}</div>
                  </div>
                </div>
                <div class="text-right">
                  <div class="ev-quant-destaque text-primary m-0">{{ item.QUANT.toLocaleString('pt-BR', {minimumFractionDigits: 3}) }} <small>KG</small></div>
                  <div class="font-xs text-muted text-uppercase">Quantidade Pedida</div>
                </div>
              </div>

              <!-- Corpo do Card -->
              <div class="p-4">
                <div class="d-flex align-items-center justify-content-between mb-3">
                  <div class="font-weight-bold text-muted small"><i class="fa fa-cubes mr-2 text-info"></i>LOTES DISPONÍVEIS EM ESTOQUE</div>
                  <b-button size="sm" variant="outline-primary" pill @click="usarTudoDisponivel(item)">
                    VINCULAR TUDO DISPONÍVEL
                  </b-button>
                </div>

                <div class="ev-lotes-grid">
                  <div v-for="lote in item.lotes" :key="lote.LOTE" 
                       class="ev-lote-card p-3 mb-2 rounded border d-flex align-items-center gap-4 transition-all"
                       :class="{'ev-lote-card--active': Number(lote.QUANT_PLANEJADA) > 0}">
                    <div class="flex-grow-1">
                      <div class="d-flex align-items-center gap-2">
                        <div class="font-weight-bold text-dark">LOTE: {{ lote.LOTE }}</div>
                        <span v-if="lote.DATA_VALIDADE" class="badge badge-light border text-muted">Val: {{ moment(lote.DATA_VALIDADE).format('DD/MM/YYYY') }}</span>
                      </div>
                      <div class="font-xs text-muted mt-1">Saldo Atual: <strong class="text-info">{{ lote.QUANT_SALDO.toLocaleString('pt-BR', {minimumFractionDigits: 3}) }}</strong></div>
                    </div>

                    <div class="d-flex align-items-center gap-2">
                      <b-button variant="soft-info" size="sm" pill class="px-3" @click="vincularSaldoLote(lote, item)">
                        USAR SALDO
                      </b-button>
                      <div style="width: 160px">
                        <vue-autonumeric
                          v-model="lote.QUANT_PLANEJADA"
                          :options="{ digitGroupSeparator: '.', decimalCharacter: ',', decimalPlaces: 3, minimumValue: '0', outputFormat: 'number' }"
                          class="form-control form-control-lg text-right font-weight-bold ev-input-large"
                          @input="onVinculoLoteChange(item)"
                        />
                      </div>
                      <b-button variant="soft-danger" size="sm" pill @click="lote.QUANT_PLANEJADA = 0; onVinculoLoteChange(item)">
                        <i class="fa fa-times"></i>
                      </b-button>
                    </div>
                  </div>
                </div>

                <!-- Barra de Progresso do Card -->
                <div class="mt-4 pt-3 border-top d-flex align-items-center justify-content-between">
                  <div class="flex-grow-1 mr-4">
                    <b-progress :value="(somaLotes(item) / item.QUANT) * 100" :max="100" :variant="somaLotes(item) > item.QUANT ? 'danger' : 'success'" style="height: 8px; border-radius: 4px;" />
                  </div>
                  <div class="text-right" style="min-width: 150px;">
                    <div class="h5 m-0 font-weight-bold" :class="somaLotes(item) > item.QUANT ? 'text-danger' : 'text-success'">
                      {{ somaLotes(item).toLocaleString('pt-BR', {minimumFractionDigits: 3}) }} KG
                    </div>
                    <div class="font-xs text-muted text-uppercase">Total Vinculado ({{ Math.round((somaLotes(item) / item.QUANT) * 100) }}%)</div>
                  </div>
                </div>
              </div>
            </div>
            
            <!-- Espaçador final para o scroll -->
            <div style="height: 100px;"></div>
          </div>
        </b-overlay>
      </div>

      <template #modal-footer="{ ok, cancel }">
        <b-button variant="light" pill class="px-4 text-muted" @click="cancel()">
           FECHAR SEM SALVAR
        </b-button>
        <b-button variant="primary" pill class="px-5 shadow font-weight-bold" @click="ok()">
          <i class="fa fa-save mr-2"></i>CONFIRMAR VÍNCULOS E PLANEJAMENTO
        </b-button>
      </template>
    </b-modal>
</div>
  
</template>

<script>
import HeaderPadrao from '@/components/Cec/HeaderPadrao.vue'
import VueButtonSpinner from '../../../components/VueButtonSpinner.vue'
import moment from 'moment'
import { imprimirRelatorioExpedicao } from './OrdemExpedicaoRelatorio'
import VueAutonumeric from 'vue-autonumeric'
import FuncionarioDropdown from '../../componentes/dropdown/FuncionarioDropdown.vue'
import VeiculoDropdown from '../../componentes/dropdown/VeiculoDropdown.vue'

export default {
  components: {
    HeaderPadrao,
    VueButtonSpinner,
    VeiculoDropdown,
    VueAutonumeric,
    FuncionarioDropdown
  },
  data () {
    return {
      isLoading: false,
      status: '',
      submmited: false,
      monitoraAlteracao: false,
      registroMonitoramento: [],
      itensForamAlterados: false,
      
      registro: {
        ID                 : null,
        DATA_CADASTRO      : null,
        NUMERO             : null,
        MOTORISTA_ID       : null,
        PLACA              : null,
        OBSERVACOES        : null,
        DATA               : null,
        RESPONSAVEL_ID     : null,
        USUARIO_CADASTRO   : null,
        STATUS             : null,
        OBS_EXCLUSAO       : null,
        USUARIO_EXCLUSAO   : null,
        DATA_EXCLUSAO      : null,
        PLACA_CARRETA      : null,
        DATA_ALTERACAO     : null,
        USUARIO_ALTERACAO  : null,
        MOTIVO_ALTERACAO   : null,
        HORA_INICIO        : null,
        HORA_TERMINO       : null,
        DATA_EMBARQUE      : null,
        USUARIO_EMBARQUE   : null,
        USUARIO_REABRIR    : null,
        DATA_REABRIR       : null,
        VEICULO_ID         : null,
        TEMPERATURA_INICIAL: null,
        TEMPERATURA_MEIO   : null,
        TEMPERATURA_FINAL  : null,
      },
      activeIndex: 0,
      itensPedidoLote: [],
      pedidoLoteEdicao: null,
      carregandoLotes: false,
      parametrosGerais: {
        OP_EXPEDICAO_POR_LOTE: '0'
      },
      tipoFechamento: [
        {value: '0', text: '0 - FECHAMENTO DIARIO'},
        {value: '1', text: '1 - FECHAMENTO DO LOTE'}
      ],
      tipoServico: [
        {value: '1', text: '1 - PRÓPRIO'},
        {value: '2', text: '2 - SERVIÇO'}
      ],
      tabelaPedidosDisponiveis: {
        isLoading : false,
        isBusy: false,
        currentPage: 1,
        perPage: 100,
        fields: [
          {
            key: "DETALHE",
            label: '',
            thStyle: { width: "3%" },
            thClass: "text-center",
            sortable: true,
            class: "text-center"
          },
          {
            key: "N_VENDA",
            label: 'Pedido',
            sortable: true,
            thStyle: { width: "10%" }
          },
          {
            key: "OP_PEDIDO",
            label: 'Tipo',
            sortable: true,
            thStyle: { width: "10%" }
          },
          {
            key: "NOME_CLIENTE",
            label: 'Cliente',
            sortable: true,
            thStyle: { width: "15%" }
          },
          {
            key: "DT_PEDIDO",
            label: 'Data', 
            sortable: true,
            formatter: (value, key, item) => 
              value ? moment(String(value)).format('DD/MM/YYYY') : null,
            thStyle: { width: "10%" }
          },
          {
            key: "NOME_VENDEDOR",
            sortable: true,
            label: 'Vendedor',
            thStyle: { width: "15%" }
          },
          {
            key: "NOME_MUNICIPIO",
            sortable: true,
            label: 'Cidade',
            thStyle: { width: "10%" }
          },
          {
            key: "actions" ,
            sortable: true,
            label: 'Ações',
            class:'text-right',
            thStyle: { width: "10%" }
          }
        ],
        items: []
      },
      tabelaPedidosEmbarcados: {
        isLoading : false,
        isBusy: false,
        currentPage: 1,
        perPage: 100,
        fields: [
          {
            key: "DETALHE",
            label: '',
            thStyle: { width: "3%" },
            thClass: "text-center",
            sortable: true,
            class: "text-center"
          },
          {
            key: "actions" ,
            label: 'Ações',
            class:'text-right',
            sortable: true,
            thStyle: { width: "10%" }
          },
          {
            key: "NENTREGA",
            class:'text-right',
            sortable: true,
            label: 'Entrega'
          },
          {
            key: "N_VENDA",
            class:'text-right',
            sortable: true,
            label: 'Pedido'
          },
          {
            key: "NOME_CLIENTE",
            class:'text-left',
            sortable: true,
            label: 'Cliente'
          },
          {
            key: "NOME_VENDEDOR",
            class:'text-left',
            sortable: true,
            label: 'Vendedor'
          },
          {
            key: "OP_PEDIDO",
            class:'text-left',
            sortable: true,
            label: 'Tipo'
          },
          {
            key: "ABATE_ID",
            class:'text-right',
            sortable: true,
            label: 'Lote'
          },
          {
            key: "actions",
            label: 'Ações',
            class: 'text-right',
            thStyle: { width: "10%" }
          }
        ],
        items: []
      },
      tabelaItens: {
        fields: [
          {
            key: "CONTROLE",
            class:'text-right', 
            thStyle: { width: "5%" },
            sortable: true,
            label: 'ID'
          },
          {
            key: 'NOME_PRODUTO',
            thStyle: { width: "30%" },
            sortable: true,
            label: 'Produto'
          },
          {
            key: 'PECAS_PEDIDO',
            class:'text-right', 
            sortable: true,
            thStyle: { width: "10%" },
            label: 'Peças'
          },
          {
            key: 'QUANT',
            class:'text-right', 
            sortable: true,
            thStyle: { width: "10%" },
            label: 'Quantidade',
            formatter: (value) => 
              value ? value.toLocaleString('pt-BR', {minimumFractionDigits: 3}) : '0,000'
          },
          {
            key: 'TX_UNIDADE_COMERCIAL',
            class:'text-center', 
            sortable: true,
            thStyle: { width: "5%" },
            label: 'UN'
          },
          {
            key: 'VL_UNT',
            class:'text-right', 
            thStyle: { width: "10%" },
            sortable: true,
            label: 'Vl. Unit',
            formatter: (value) => 
              value ? value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 'R$ 0,00'
          },
          {
            key: 'VL_TOTAL',
            class:'text-right', 
            thStyle: { width: "15%" },
            sortable: true,
            label: 'Vl. Total',
            formatter: (value) => 
              value ? value.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'}) : 'R$ 0,00'
          }
        ]
      },
      totalizados: {
        agrupamento: 'produto',
        dados: [],
        fields: [
          { 
            key: 'DETALHE', 
            label: '',
            thStyle: { width: '3%' },
            thClass: 'text-center',
            class: 'text-center'
          },
          { 
            key: 'CODIGO', 
            label: 'Código',
            sortable: true,
            thStyle: { width: '10%' },
            class: 'text-right'
          },
          { 
            key: 'AGRUPAMENTO', 
            label: 'Descrição',
            sortable: true,
            thStyle: { width: '27%' }
          },
          { 
            key: 'QUANT', 
            label: 'Quantidade (Kg)',
            class: 'text-right',
            sortable: true,
            thStyle: { width: '20%' }
          },
          { 
            key: 'PECAS', 
            label: 'Peças Embarcadas',
            class: 'text-right',
            sortable: true,
            thStyle: { width: '20%' }
          },
          { 
            key: 'PECAS_PEDIDO', 
            label: 'Peças Pedido',
            class: 'text-right',
            sortable: true,
            thStyle: { width: '20%' }
          }
        ]
      },
      tabelaProdutosCliente: {
        fields: [
          {
            key: 'COD_PRO',
            label: 'Cód. Produto',
            thStyle: { width: '15%' },
            class: 'text-right'
          },
          {
            key: 'NOME_PRODUTO',
            label: 'Produto',
            thStyle: { width: '40%' }
          },
          {
            key: 'QUANT',
            label: 'Quantidade (Kg)',
            class: 'text-right',
            thStyle: { width: '15%' },
            formatter: (value) => 
              value ? value.toLocaleString('pt-BR', {minimumFractionDigits: 3}) : '0,000'
          },
          {
            key: 'PECAS',
            label: 'Peças Embarcadas',
            class: 'text-right',
            thStyle: { width: '15%' }
          },
          {
            key: 'PECAS_PEDIDO',
            label: 'Peças Pedido',
            class: 'text-right',
            thStyle: { width: '15%' }
          }
        ]
      },
         
      optionsRaca: [],
      optionsCor: [],
      optionsSexo: [
       {value: 'M', text: 'MACHO'},
       {value: 'F', text: 'FEMEA'}
      ],
      pedidoEdicao: null,
      novoNEntrega: 0,
      
      // Lotes
      pedidoLoteEdicao: null,
      itensPedidoLote: [],
      carregandoLotes: false
      
    }
  },
  methods: {
    isValid() {
      return     this.registro.DATA 
              && this.registro.NUMERO        
              && this.registro.RESPONSAVEL_ID
              && this.registro.MOTORISTA_ID
              && this.registro.VEICULO_ID
              && this.registro.PLACA
    },
    traduzirTipoPedido (tipo) {
      if (!tipo) return 'INDEFINIDO'
      
      switch (tipo) {
        case  '1' : return 'VENDA'
        case  '2' : return 'SERVIÇO' 
        default: 'INDEFINIDO'
          break;
      }

    },
    colorirTipoPedido (tipo) {
      if (!tipo) return 'secondary'
      
      switch (tipo) {
        case  '1' : return 'primary'
        case  '2' : return 'info' 
        default: 'secondary'
          break;
      }

    },
    onVoltarPrincipal() {
      if (!this.compararObjetos(this.registro, this.registroMonitoramento)) {
        this.$store.commit('controle/setAguardando', true)
        this.$store
        .dispatch('ordemExpedicao/GERAR_LISTA')
        .then(() => {
          this.$store.commit('controle/setAguardando', false)
          this.$router.go(-1)
          return
        }).catch((error) => {
          if (error) {
            this.$root.$bvToast.toast(`Não foi possível atualizar a Lista de Ordens de Abate \n Tente Filtrar Manualmente!!!`, {
            title: 'Aviso',
            autoHideDelay: 2000,
            variant: 'warning',
            appendToast: true
          })
          this.$router.go(-1)
          }
        })
      } else {
        this.$router.go(-1)
      }
    },
    atualizarListaPedidosDisponiveis () {
      this.tabelaPedidosDisponiveis.isBusy = true
      
      return new Promise((resolve, reject) => {
        this.$http.get(`/api/protected/ordemexpedicao/getPedidosAbertos`)
        .then(result =>{
          if (Array.isArray(result) && !result.length ) {
            result.forEach(pedido => {
              if (pedido.DT_PEDIDO) {
                pedido.DT_PEDIDO = moment(new Date(pedido.DT_PEDIDO)).format('YYYY-MM-DD')
              }
            })  
          }
          this.tabelaPedidosDisponiveis.items = result.data
          this.tabelaPedidosDisponiveis.isBusy = false
          resolve(true)
        })
        .catch(erro => {
          this.tabelaPedidosDisponiveis.isBusy = false
          this.$store.commit('controle/setAguardando', false)

          if (erro.response && erro.response.status && erro.response.status === 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Falha: ${erro.response.data}`, {
              title: 'Falha',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          } else {
            this.toastCount++
            this.$root.$bvToast.toast(`Falha ao atualizar lista de Pedidos ${erro}`, {
              title: 'Falha',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          }
          
          reject(false)
        })
      })
    },
    async atualizarListaPedidosEmbarcados () {
      return new Promise((resolve, reject) => {
        this.$http.get(`/api/protected/ordemexpedicao/getPedidosEmbarcados/${this.registro.ID}`)
        .then(result =>{
          this.tabelaPedidosEmbarcados.items = result.data
          resolve(true)
          return
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          

          if (erro.response && erro.response.status && erro.response.status === 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Falha: ${erro.response.data}`, {
              title: 'Falha',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          } else {
            this.toastCount++
            this.$root.$bvToast.toast(`Falha ao atualizar lista de Pedidos ${erro}`, {
              title: 'Falha',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          }
          reject(false)
        })
      })
    },
    addPedido (pedidoId) {
      this.tabelaPedidosDisponiveis.isLoading = true
      
      let pacote = {
        ordemExpedicao : this.registro,
        pedidoId : pedidoId,
        usuario : window.localStorage.getItem('login')
      }
      

      this.$http.post(`/api/protected/ordemexpedicao/addPedido`, pacote)
      .then( async (result) =>{
        if (result.data.DATA) {
          result.data.DATA = new Date(result.data.DATA).toJSON().slice(0, 10)
        }
        if (result.data.DATA_CADASTRO) {
          
          result.data.DATA_CADASTRO = new Date(result.data.DATA_CADASTRO).toJSON().slice(0, 10)
        }
        this.registro = result.data
        //necessario para lembrar o ID quando voltar a listagem
        this.$store.commit("ordemExpedicao/SET_REGISTRO_ID", this.registro.ID)

        await this.atualizarListaPedidosDisponiveis()
        await this.atualizarListaPedidosEmbarcados()
        await this.buscarDetalhesPedidosDaOrdem()
        
        this.tabelaPedidosDisponiveis.isLoading = false
        
        return

      })
      .catch(erro => {
        this.tabelaPedidosDisponiveis.isLoading = false
        if (erro.response && erro.response.status && erro.response.status === 400) {
          this.toastCount++
          this.$root.$bvToast.toast(`Atenção: ${erro.response.data}`, {
            title: 'Atenção',
            autoHideDelay: 3000,
            variant: 'warning',
            appendToast: true
          })
        } else {
          this.tabelaPedidosDisponiveis.isLoading = false
          this.toastCount++
          this.$root.$bvToast.toast(`Atenção: Não foi possivel adicionar o Pedido na Ordem`, {
            title: 'Atenção',
            autoHideDelay: 3000,
            variant: 'warning',
            appendToast: true
          })
        }
        this.tabelaPedidosDisponiveis.isLoading = false
        return
      })
      
    },
    delPedido (pedidoId) {
      this.tabelaPedidosEmbarcados.isLoading = true
      let pacote = {
        ordemExpedicao : this.registro,
        pedidoId : pedidoId
      }
      
      
      this.$http.post(`/api/protected/ordemexpedicao/delPedido`, pacote)
      .then( async (result) =>{
        
        if (result.data.DATA) {
          result.data.DATA = new Date(result.data.DATA).toJSON().slice(0, 10)
        }
        
        if (result.data.DATA_CADASTRO) {
          result.data.DATA_CADASTRO = new Date(result.data.DATA_CADASTRO).toJSON().slice(0, 10)
        }
      
        this.registro = result.data
      
        await this.atualizarListaPedidosDisponiveis()
      
        await this.atualizarListaPedidosEmbarcados()
      
        await this.buscarDetalhesPedidosDaOrdem()
        
        this.tabelaPedidosEmbarcados.isLoading = false
        
        return

      })
      .catch(erro => {
        this.tabelaPedidosEmbarcados.isLoading = false
        if (erro.response && erro.response.status && erro.response.status === 400) {
          this.toastCount++
          this.$root.$bvToast.toast(`Atenção: ${erro.response.data}`, {
            title: 'Atenção',
            autoHideDelay: 3000,
            variant: 'warning',
            appendToast: true
          })
        } else {
          this.tabelaPedidosEmbarcados.isLoading = false
          this.toastCount++
          this.$root.$bvToast.toast(`Atenção: Não foi possivel adicionar o Pedido na Ordem`, {
            title: 'Atenção',
            autoHideDelay: 3000,
            variant: 'warning',
            appendToast: true
          })
        }
        this.tabelaPedidosEmbarcados.isLoading = false
        return
      })
      
    },
    async buscarDetalhesPedido(id) {
      // Busca detalhes dos itens do pedido - mesmo endpoint de VendaListagem
      const itensResult = await this.$http.get('/api/protected/venda/item/getListagemByVenda/'+id)
      return itensResult.data ?? null
    },
    async toggleDetalhesPedido(row) {
      if (row.detailsShowing) {
        row.toggleDetails()
        return
      }

      // SEMPRE buscar dados novamente (remover cache)
      this.$set(row.item, 'loading', true)
      
      const detalhes = await this.buscarDetalhesPedido(row.item.SEQUENCIA)
      
      this.$set(row.item, 'detalhes', detalhes)
      this.$set(row.item, 'loading', false)

      row.toggleDetails()
    },
    async buscarDetalhesPedidosDaOrdem() {
      if (!this.registro.ID) return
      
      try {
        const result = await this.$http.get(`/api/protected/ordemexpedicao/getDetalhesPedidosDaOrdem/${this.registro.ID}`)
        this.totalizados.dados = result.data || []
      } catch (erro) {
        console.error('Erro ao buscar detalhes dos pedidos:', erro)
        this.totalizados.dados = []
      }
    },
    async imprimirTotalizados() {
      if (!this.registro.ID || !this.totalizadosAgrupados.length) return

      const tiposMap = {
        produto:   'Produto',
        cliente:   'Cliente',
        vendedor:  'Vendedor',
        municipio: 'Município'
      }
      const tipoAgrupamento = tiposMap[this.totalizados.agrupamento] || 'Produto'

      // Resolve nome do motorista via API se disponível
      let nomeMotorista = ''
      if (this.registro.MOTORISTA_ID) {
        try {
          const resp = await this.$http.get(`/api/protected/funcionario/getById/${this.registro.MOTORISTA_ID}`)
          if (resp.data && resp.data.length > 0 && resp.data[0].NOME) {
            nomeMotorista = resp.data[0].NOME
          }
        } catch (e) {
          console.error('Erro ao buscar motorista:', e)
        }
      }

      await imprimirRelatorioExpedicao({
        ordem:          this.registro,
        rows:           this.totalizadosAgrupados,
        totalGeral:     this.totalGeral,
        tipoAgrupamento,
        nomeMotorista,
        dadosDetalhados: this.totalizados.dados,
        empresa:        {}
      })
    },
    toggleDetalhesTotalizados(row) {
      // Apenas funciona para agrupamento por cliente
      if (this.totalizados.agrupamento !== 'cliente') {
        return
      }

      // Se já está aberto, apenas fecha
      if (row.detailsShowing) {
        row.toggleDetails()
        return
      }

      // Marca como carregando
      this.$set(row.item, 'loading', true)

      // Processa dados locais para agrupar produtos do cliente
      const codigoCliente = row.item.CODIGO
      const produtosDoCliente = {}

      // Filtra e agrupa produtos deste cliente
      this.totalizados.dados.forEach(item => {
        if (item.COD_CLI === codigoCliente) {
          const codPro = item.COD_PRO
          if (!produtosDoCliente[codPro]) {
            produtosDoCliente[codPro] = {
              COD_PRO: item.COD_PRO,
              NOME_PRODUTO: item.NOME_PRODUTO,
              QUANT: 0,
              PECAS: 0,
              PECAS_PEDIDO: 0
            }
          }
          produtosDoCliente[codPro].QUANT += Number(item.QUANT || 0)
          produtosDoCliente[codPro].PECAS += Number(item.PECAS || 0)
          produtosDoCliente[codPro].PECAS_PEDIDO += Number(item.PECAS_PEDIDO || 0)
        }
      })

      // Converte para array
      const detalhes = Object.values(produtosDoCliente)

      // Define os detalhes
      this.$set(row.item, 'detalhes', detalhes)
      this.$set(row.item, 'loading', false)

      // Abre o detalhe
      row.toggleDetails()
    },
    onGravarNovo () {
      if (!this.isValid()) {
        this.$root.$bvToast.toast(`Preencha todos os campos obrigatórios!!!`, {
          title: 'Aviso',
          autoHideDelay: 2000,
          variant: 'danger',
          appendToast: true
        })
        
        return
      }
      
      this.$store.commit('controle/setAguardando', true)    

      if (this.registro.STATUS ) {
        this.registro.STATUS = '1' // Planejamento Iniciado
      } else {
        this.registro.STATUS = '2' //Liberar para Terminal
      }
      
      this.registro.USUARIO_CADASTRO = window.localStorage.getItem('login')
      this.$http.post(`/api/protected/ordemexpedicao/post`, this.registro)
      .then((response) => {
        this.$store.commit('controle/setAguardando', false)
        this.toastCount++
        this.$root.$bvToast.toast(`Ordem de Abate Gravada com Sucesso!!!`, {
          title: 'Aviso',
          autoHideDelay: 3000,
          variant: 'success',
          appendToast: true
        })
        if (response.length === 0 ) {
         this.$route.go(-1) 
        } else {
          // this.iniciarAlteracao(response.data[0].ID)
          this.registro.ID = response.data[0].ID
          this.registro.DATA = new Date(response.data[0].DATA).toJSON().slice(0, 10)
          this.registro.DATA_CADASTRO = new Date(response.data[0].DATA_CADASTRO).toJSON().slice(0, 10)
          this.registro.STATUS = response.data[0].STATUS

          //necessario para lembrar o ID quando voltar a listagem
          this.$store.commit("ordemExpedicao/SET_REGISTRO_ID", response.data[0].ID)

        }
      })
      .catch(erro => {
        this.$store.commit('controle/setAguardando', false)
        if (erro.response.status == 400) {
          this.toastCount++
          this.$root.$bvToast.toast(`Atenção: ${erro.response.data}`, {
            title: 'Atenção',
            autoHideDelay: 3000,
            variant: 'warning',
            appendToast: true
          })
        }
      })
    },
    onGravarEditar () {
      if (!this.isValid()) {
        this.$root.$bvToast.toast(`Preencha todos os campos obrigatórios!!!`, {
          title: 'Aviso',
          autoHideDelay: 2000,
          variant: 'danger',
          appendToast: true
        })
        
        return
      }
      
      this.$store.commit('controle/setAguardando', true)    
      this.$http.post(`/api/protected/producao/resumo/edit`, this.registro)
      .then(() => {
        
        this.$store.dispatch('abateResumo/GERAR_LISTA')
        .then(() => {
          this.$store.commit('controle/setAguardando', false)
          this.toastCount++
          this.$root.$bvToast.toast(`ALTERAÇÕES gravadas com Sucesso!!!`, {
            title: 'Aviso',
            autoHideDelay: 3000,
            variant: 'success',
            appendToast: true
          })
          this.$router.go(-1)
          return
        })
        .catch((error) => {
          if (error) {
            this.$root.$bvToast.toast(`Não foi possível atualizar o Resumo \n Tente Filtrar Manualmente!!!`, {
            title: 'Aviso',
            autoHideDelay: 2000,
            variant: 'warning',
            appendToast: true
          })
          this.$router.go(-1)
          }
        }) 
      })
      .catch(erro => {
        this.$store.commit('controle/setAguardando', false)
        if (erro.response.status == 400) {
          this.toastCount++
          this.$root.$bvToast.toast(`Atenção: ${erro.response.data}`, {
            title: 'Atenção',
            autoHideDelay: 3000,
            variant: 'warning',
            appendToast: true
          })
        }
      })
    },
    onLiberarTerminal () {
      if (!this.isValid()) {
        this.$root.$bvToast.toast(`Preencha todos os campos obrigatórios!!!`, {
          title: 'Aviso',
          autoHideDelay: 2000,
          variant: 'danger',
          appendToast: true
        })
        return
      }
     /* 
      if ( (this.tabelaPedidosDisponiveis.items.length === 0 )) {
        this.$root.$bvToast.toast(`É necessário lançar o cadastro dos produtos!!!`, {
          title: 'Aviso',
          autoHideDelay: 2000,
          variant: 'danger',
          appendToast: true
        })
        return
      }
*/
      // Validação de Lotes (se configurado)
      if (this.parametrosGerais.OP_EXPEDICAO_POR_LOTE === '1') {
        const pedidosPendentes = this.tabelaPedidosEmbarcados.items.filter(p => p.QUANT_VINCULADA < p.QUANT_TOTAL_ITENS)
        if (pedidosPendentes.length > 0) {
          this.$root.$bvToast.toast(`Existem pedidos com planejamento de lotes pendente ou parcial. Vincule todos os lotes antes de liberar para o terminal!`, {
            title: 'Bloqueio de Segurança',
            autoHideDelay: 5000,
            variant: 'warning',
            appendToast: true
          })
          return
        }
      }

      this.$store.commit('controle/setAguardando', true)    
      this.$http.post(`/api/protected/ordemexpedicao/liberarTerminal/`,this.registro)
      .then(() => {
        
        this.$store.dispatch('ordemExpedicao/GERAR_LISTA')
        .then(() => {
          //necessario para lembrar o ID quando voltar a listagem
          this.$store.commit("ordemExpedicao/SET_REGISTRO_ID", this.registro.ID)
          this.$store.commit('controle/setAguardando', false)
          this.$router.go(-1)
          return
        })
        .catch((error) => {
          if (error) {
            this.$root.$bvToast.toast(`Não foi possível atualizar as Ordens \n Tente Filtrar Manualmente!!!`, {
            title: 'Aviso',
            autoHideDelay: 2000,
            variant: 'warning',
            appendToast: true
          })
          this.$router.go(-1)
          }
        }) 
      })
      .catch(erro => {
        this.$store.commit('controle/setAguardando', false)
        if (erro.response.status == 400) {
          this.toastCount++
          this.$root.$bvToast.toast(`Atenção: ${erro.response.data}`, {
            title: 'Atenção',
            autoHideDelay: 3000,
            variant: 'warning',
            appendToast: true
          })
        }
      })
    },
    onReabrir () {
      this.$store.commit('controle/setAguardando', true)    
      return this.$http.post(`/api/protected/ordemexpedicao/reabrir/${this.registro.ID}`)
      .then((response) => {
        this.$store.commit('controle/setAguardando', false)    
        if (response.data.ID) {
          this.registro.ID = response.data.ID
          this.registro.DATA = new Date(response.data.DATA).toJSON().slice(0, 10)
          this.registro.DATA_CADASTRO = new Date(response.data.DATA_CADASTRO).toJSON().slice(0, 10)
          this.registro.STATUS = response.data.STATUS
        } else {
          this.toastCount++
          this.$root.$bvToast.toast(`Não foi possivel reabrir a Ordem`, {
            title: 'Atenção',
            autoHideDelay: 3000,
            variant: 'warning',
            appendToast: true
          })
          return
        }
      })
      .catch(erro => {
        this.$store.commit('controle/setAguardando', false)
        if (erro.response.status == 400) {
          this.toastCount++
          this.$root.$bvToast.toast(`Atenção: ${erro.response.data}`, {
            title: 'Atenção',
            autoHideDelay: 3000,
            variant: 'warning',
            appendToast: true
          })
        }
      })
    },
    async getRegistroById(id) {
      return new Promise(resolve => {
        this.$http.get(`/api/protected/ordemexpedicao/getById/${id}`)
        .then((result) =>{
          resolve(result)
        })
        .catch(erro => {
          this.$store.commit('controle/setAguardando', false)
          if (erro.response.status == 400) {
            this.toastCount++
            this.$root.$bvToast.toast(`Atenção: ${erro.response.data}`, {
              title: 'Atenção',
              autoHideDelay: 3000,
              variant: 'warning',
              appendToast: true
            })
          }
          resolve(false)
        })
      })
        
    },
    async iniciarAlteracao(id) {
      let reg = await this.getRegistroById(id)
      if (reg == null) {
        
        this.$store.commit('controle/setAguardando', false)
        this.$bvToast.toast(`Falha ao localizar a Ordem!!`, {
          title: 'Erro',
          autoHideDelay: 5000,
          variant: 'warning',
          appendToast: true
        })
        this.$store.commit('controle/setAguardando', false)
        this.$router.go(-1)
        return
      }
      
      reg.data[0].DATA = new Date(reg.data[0].DATA).toJSON().slice(0, 10)
      reg.data[0].DATA_CADASTRO = new Date(reg.data[0].DATA_CADASTRO).toJSON().slice(0, 10)
     
      
      this.registro = reg.data[0]
      
      this.tabelaPedidosDisponiveis.items = []
      
      await this.atualizarListaPedidosDisponiveis()
      
      await this.atualizarListaPedidosEmbarcados()

      await this.buscarDetalhesPedidosDaOrdem()

      
   
      //CONTROLA ALTERACOES PARA O BOTAO ALTERAR
      this.registroMonitoramento = JSON.parse(JSON.stringify(this.registro))

      this.monitoraAlteracao = true
      this.itensForamAlterados = false

      
      this.$store.commit('controle/setAguardando', false)
      return
      
    },
    compararObjetos(a, b) {
      // Verifica se a e b são do tipo objeto
      if (typeof a !== 'object' || typeof b !== 'object') {
        return false;
      }

      // Verifica se a e b são instâncias do mesmo tipo de objeto
      if (a.constructor !== b.constructor) {
        return false;
      }

      // Obtém as chaves dos objetos
      const chavesA = Object.keys(a);
      const chavesB = Object.keys(b);

      // Verifica se o número de chaves é o mesmo
      if (chavesA.length !== chavesB.length) {
        return false;
      }

      // Verifica se os valores das chaves são iguais em ambos os objetos
      for (let chave of chavesA) {
        if (a[chave] !== b[chave]) {
          return false;
        }
      }

      // Se todas as verificações passaram, os objetos são considerados iguais
      return true;
    },
    compararArrays(a, b) {
      // Verifica se a e b são do tipo array
      if (!Array.isArray(a) || !Array.isArray(b)) {
        return false;
      }

      // Verifica se os arrays têm o mesmo comprimento
      if (a.length !== b.length) {
        return false;
      }

      // Verifica se todos os elementos nos mesmos índices são iguais
      return a.every((element, index) => element === b[index]);
    },
    limparObjeto (a) {
      let prop1 = Object.getOwnPropertyNames(a)
      for(var i = 0; i < prop1.length; i++) {
        var prop = prop1[i]
        if ((prop.indexOf("__ob__") == -1) ) {
          a[prop] = null
        }
      }
    },
    openEditEntrega(item) {
      this.pedidoEdicao = item
      this.novoNEntrega = item.NENTREGA || 0
      this.$bvModal.show('modal-editar-entrega')
    },
    salvarEntrega(bvModalEvt) {
      if (!this.pedidoEdicao) return

      // Previne o fechamento automatico
      bvModalEvt.preventDefault()

      const payload = {
        SEQUENCIA: this.pedidoEdicao.SEQUENCIA,
        NENTREGA: this.novoNEntrega
      }
      
      this.$store.commit('controle/setAguardando', true)

      this.$http.post('/api/protected/vendapedido/edit', payload)
        .then(() => {
          this.$store.commit('controle/setAguardando', false)
          this.$root.$bvToast.toast('Entrega atualizada com sucesso!', {
            title: 'Sucesso',
            variant: 'success',
            autoHideDelay: 3000,
            solid: true
          })
          
          this.$nextTick(() => {
             this.$bvModal.hide('modal-editar-entrega')
          })

          // Atualiza a lista mantendo o scroll
           const scrollY = window.scrollY
           this.atualizarListaPedidosEmbarcados().then(() => {
               this.$nextTick(() => {
                   window.scrollTo(0, scrollY)
               })
           })

        })
        .catch(error => {
          this.$store.commit('controle/setAguardando', false)
           this.$root.$bvToast.toast(`Erro ao atualizar entrega: ${error.response ? error.response.data : error}`, {
            title: 'Erro',
            variant: 'danger',
            autoHideDelay: 3000,
            solid: true
          })
        })
    },
    abrirModalVincularLotes(pedido) {
      this.pedidoLoteEdicao = pedido
      this.carregandoLotes = true
      this.$bvModal.show('modal-vincular-lotes')
      
      this.$http.get(`/api/protected/ordemexpedicao/getLotesDisponiveisPorPedido/${pedido.SEQUENCIA}`)
        .then(res => {
          this.itensPedidoLote = res.data
          this.carregandoLotes = false
        })
        .catch(err => {
          this.carregandoLotes = false
          this.$root.$bvToast.toast('Erro ao buscar lotes: ' + err, { variant: 'danger' })
        })
    },
    salvarVinculoLotes(bvModalEvt) {
      bvModalEvt.preventDefault()
      
      // Validação: Soma dos lotes não pode exceder a quantidade do item
      for (const item of this.itensPedidoLote) {
        const totalLotes = this.somaLotes(item)
        if (totalLotes > item.QUANT) {
          this.$root.$bvToast.toast(`A soma dos lotes para o produto ${item.NOME_PRODUTO} excede a quantidade pedida (${item.QUANT})`, {
            title: 'Erro de Validação',
            variant: 'danger',
            autoHideDelay: 5000
          })
          return
        }
      }

      this.$store.commit('controle/setAguardando', true)
      const payload = {
        pedidoId: this.pedidoLoteEdicao.SEQUENCIA,
        itens: this.itensPedidoLote,
        usuario: window.localStorage.getItem('login')
      }

      this.$http.post('/api/protected/ordemexpedicao/salvarVinculoLotes', payload)
        .then(() => {
          this.$store.commit('controle/setAguardando', false)
          this.$root.$bvToast.toast('Vínculos salvos com sucesso!', { variant: 'success' })
          this.$bvModal.hide('modal-vincular-lotes')
          this.atualizarListaPedidosEmbarcados()
        })
        .catch(err => {
          this.$store.commit('controle/setAguardando', false)
          this.$root.$bvToast.toast('Erro ao salvar vínculos: ' + err, { variant: 'danger' })
        })
    },
    scrollToItem(idx) {
      this.activeIndex = idx
      const cardId = 'item-card-lote-' + idx
      const el = document.getElementById(cardId)
      if (el) {
        el.scrollIntoView({ behavior: 'smooth', block: 'start' })
        
        // Foco automático no primeiro input do card
        this.$nextTick(() => {
          setTimeout(() => {
            const firstInput = document.querySelector(`#${cardId} input`)
            if (firstInput) {
              firstInput.focus()
              if (typeof firstInput.select === 'function') firstInput.select()
            }
          }, 400)
        })
      }
    },
    vincularSaldoLote(lote, item) {
      const totalOutrosLotes = item.lotes.filter(l => l.LOTE !== lote.LOTE).reduce((acc, l) => acc + Number(l.QUANT_PLANEJADA || 0), 0)
      const faltaVinculo = Math.max(0, item.QUANT - totalOutrosLotes)
      lote.QUANT_PLANEJADA = Math.min(lote.QUANT_SALDO, faltaVinculo)
      this.onVinculoLoteChange(item)
    },
    onVinculoLoteChange(item) {
      // Força re-render se necessário
      this.$forceUpdate()
    },
    usarTudoDisponivel(item) {
      if (!item.lotes) return
      let saldoNecessario = item.QUANT
      item.lotes.forEach(l => {
        const usar = Math.min(l.QUANT_SALDO, saldoNecessario)
        l.QUANT_PLANEJADA = usar
        saldoNecessario -= usar
      })
      this.onVinculoLoteChange(item)
    },
    calcProgressoGeralVinculo() {
      if (!this.itensPedidoLote || !this.itensPedidoLote.length) return 0
      const totalPedido = this.itensPedidoLote.reduce((acc, i) => acc + i.QUANT, 0)
      const totalVinculado = this.itensPedidoLote.reduce((acc, i) => acc + this.somaLotes(i), 0)
      if (totalPedido === 0) return 0
      return Math.round((totalVinculado / totalPedido) * 100)
    },
    moment(v) {
      return moment(v)
    }
    
  },
  computed: {
    totalizadosAgrupados() {
      if (!this.totalizados.dados || !this.totalizados.dados.length) {
        return []
      }
      const mapa = {}
      let campoCodigo, campoNome
      
      switch(this.totalizados.agrupamento) {
        case 'produto':
          campoCodigo = 'COD_PRO'
          campoNome = 'NOME_PRODUTO'
          break
        case 'cliente':
          campoCodigo = 'COD_CLI'
          campoNome = 'NOME_CLIENTE'
          break
        case 'vendedor':
          campoCodigo = 'COD_VENDEDOR'
          campoNome = 'NOME_VENDEDOR'
          break
        case 'municipio':
          campoCodigo = 'MUNICIPIO_ID'
          campoNome = 'NOME_MUNICIPIO'
          break
      }

      this.totalizados.dados.forEach(item => {
        const codigo = item[campoCodigo] || ''
        const nome = item[campoNome] || '-- Não informado --'
        const chave = `${codigo}|${nome}`
        
        if (!mapa[chave]) {
          mapa[chave] = { codigo, nome, QUANT: 0, PECAS: 0, PECAS_PEDIDO: 0 }
        }
        mapa[chave].QUANT += Number(item.QUANT || 0)
        mapa[chave].PECAS += Number(item.PECAS || 0)
        mapa[chave].PECAS_PEDIDO += Number(item.PECAS_PEDIDO || 0)
      })

      return Object.keys(mapa).map(key => ({
        CODIGO: mapa[key].codigo,
        AGRUPAMENTO: mapa[key].nome,
        QUANT: mapa[key].QUANT,
        PECAS: mapa[key].PECAS,
        PECAS_PEDIDO: mapa[key].PECAS_PEDIDO
      }))
    },
    somaLotes() {
      return (item) => {
        if (!item || !item.lotes) return 0
        return item.lotes.reduce((acc, lote) => acc + Number(lote.QUANT_PLANEJADA || 0), 0)
      }
    },
    totalGeral() {
      if (!this.totalizadosAgrupados || !this.totalizadosAgrupados.length) {
        return { QUANT: 0, PECAS: 0, PECAS_PEDIDO: 0 }
      }
      
      return this.totalizadosAgrupados.reduce((acc, item) => {
        acc.QUANT += Number(item.QUANT || 0)
        acc.PECAS += Number(item.PECAS || 0)
        acc.PECAS_PEDIDO += Number(item.PECAS_PEDIDO || 0)
        return acc
      }, { QUANT: 0, PECAS: 0, PECAS_PEDIDO: 0 })
    },
    exibirBotaoGravar: function() {
      return (!this.registro.ID) 
    },
    exibirBotaoFinalizar: function() {
      return  (this.registro.STATUS == '1')
    },
    exibirBotaoReabrir :function() {
      return (['2','3','4']).includes(this.registro.STATUS)  ? true : false
    },
    desabilitarQuandoFechado: function () {
      return (['2','3','4']).includes(this.registro.STATUS)  ? true : false
    },
    traduzStatus : function () {
      if (this.registro.STATUS == null) return 'EM CADASTRO'
      
      switch (this.registro.STATUS) {
        case  '0' : return 'CANCELADO'
        case  '1' : return 'EM CADASTRO' 
        case  '2' : return 'AGUARDANDO EMBARQUE' 
        case  '3' : return 'EMBARCANDO' 
        case  '4' : return 'FINALIZADO' 
        default:
          break;
      }

    }
  },
  async created () {
    // nao monitorar o botao gravar
    this.monitoraAlteracao = false
    this.registroMonitoramento = []

    let id = this.$route.params.id
    //ALTERACAO
    if ( id ) {
        
      try {
        this.iniciarAlteracao(id)
      } catch (error) {
        this.toastCount++
        this.$root.$bvToast.toast(`Não foi possivel iniciar a alteração`, {
          title: 'Atenção',
          autoHideDelay: 300,
          variant: 'success',
          appendToast: true
        })
        this.$route.go(-1)
        return
      }
    } 
    //NOVO REGISTRO
    else {
      let registroVazio           = JSON.parse(JSON.stringify(this.registro))
      registroVazio.DATA          = moment(new Date()).format('YYYY-MM-DD')
      registroVazio.DATA_CADASTRO = moment(new Date()).format('YYYY-MM-DD')
      registroVazio.STATUS        = '1'
      
      this.registro = JSON.parse(JSON.stringify(registroVazio))
      this.registroMonitoramento = JSON.parse(JSON.stringify(registroVazio))

      this.tabelaPedidosDisponiveis.items = []
      this.tabelaPedidosEmbarcados.items = []
      await this.atualizarListaPedidosDisponiveis()
      this.$store.commit('controle/setAguardando', false)
    }

    // Carregar parâmetros (para ambos os casos)
    this.$http.get('/api/protected/parametro/getDados')
      .then(res => {
        if (res.data && res.data.length > 0) {
          this.parametrosGerais.OP_EXPEDICAO_POR_LOTE = res.data[0].OP_EXPEDICAO_POR_LOTE || '0'
        }
      })
  },
  watch: {
  }
}
</script>


<style>
  .card-header .card-alinha {
    position: absolute;
    top: 0;
    right: 0;
    
  }

 .card-header .card-alinha button {
    display: block;
    float: left;
    padding: 0.75rem 1rem;
    margin: 0 !important;
    
    text-align: center;
    
    border: 0;
    border-left: 1px solid #a4b7c1;
    -webkit-box-shadow: 0;
    box-shadow: 0;
 }
 @keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
/* Estilo para ícone giratório */
.spinner-border.spinner-border-sm {
  animation: spin 1s linear infinite;
}

/* ── ESTILOS PREMIUM MODAL LOTES (Paridade com ExpedicaoVolumesModal) ── */
.font-xs { font-size: 0.75rem; }
.font-sm { font-size: 0.85rem; }
.gap-2 { gap: 8px; }
.gap-3 { gap: 12px; }
.gap-4 { gap: 16px; }

.bg-soft-grey { background-color: #f1f5f9; }
.bg-soft-success { background-color: #ecfdf5 !important; }
.bg-soft-blue { background-color: #f0f9ff !important; }

/* ── FIXED TOP BAR ── */
.ev-fixed-top-bar { height: 64px; flex-shrink: 0; z-index: 10; }
.ev-stat-mini { padding: 0 16px; border-right: 1px solid #e2e8f0; }
.ev-stat-mini:last-child { border-right: none; }
.ev-stat-mini label { font-size: 0.6rem; font-weight: 800; color: #64748b; letter-spacing: 0.05em; margin: 0; text-transform: uppercase; }
.ev-stat-mini .value { font-size: 1.1rem; font-weight: 800; line-height: 1.2; }

/* ── SIDEBAR ── */
.ev-nav-item { cursor: pointer; transition: all 0.2s; border-left: 4px solid transparent !important; background: #fff; }
.ev-nav-item:hover { background: #f8fafc; border-left-color: #cbd5e1 !important; }
.ev-nav-item--active { background: #e0f2fe !important; border-left-color: #0369a1 !important; box-shadow: inset 0 0 10px rgba(3, 105, 161, 0.05); }
.ev-nav-item--done { background: #f0fdf4; }
.ev-nav-dot { width: 10px; height: 10px; border-radius: 50%; background: #cbd5e1; }
.ev-nav-item--active .ev-nav-dot { background: #0369a1; box-shadow: 0 0 0 4px rgba(3, 105, 161, 0.1); }
.ev-nav-item--done .ev-nav-dot { background: #22c55e; }

/* ── ITEM CARD ── */
.ev-item-card { transition: all 0.3s; border-radius: 16px !important; border: 2px solid #e2e8f0 !important; }
.ev-item-card--active { border-color: #3b82f6 !important; box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1) !important; }
.ev-item-card--done { border-color: #22c55e !important; }
.ev-item-index { width: 32px; height: 32px; background: #1e293b; color: #fff; border-radius: 8px; display: flex; align-items: center; justify-content: center; font-weight: 800; font-size: 0.9rem; }
.ev-item-card--done .ev-item-index { background: #22c55e; }

.ev-quant-destaque { font-size: 1.6rem; font-weight: 800; line-height: 1.1; }
.ev-quant-destaque small { font-size: 0.8rem; opacity: 0.7; }

/* ── LOTES ── */
.ev-lote-card { background: #f8fafc; border-color: #e2e8f0 !important; border-width: 2px !important; }
.ev-lote-card--active { background: #f1f5f9 !important; border-color: #3b82f6 !important; }
.ev-lote-card:hover { transform: translateY(-2px); box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1); }

.ev-input-large { font-size: 1.5rem !important; height: 56px !important; border-radius: 12px !important; border-color: #cbd5e1; color: #0f172a !important; }
.ev-input-large:focus { border-color: #3b82f6; box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1); background: #fff; }

/* ── BUTTONS ── */
.btn-soft-info { background: #e0f2fe; color: #0369a1; border: none; font-weight: 700; }
.btn-soft-info:hover { background: #bae6fd; }
.btn-soft-danger { background: #fee2e2; color: #b91c1c; border: none; }
.btn-soft-danger:hover { background: #fecaca; }

.transition-all { transition: all 0.2s; }
</style>


// WEBPACK FOOTER //
// src/views/expedicao/ordemexpedicao/OrdemExpedicaoCadastro.vue